import { render, staticRenderFns } from "./form-clients.vue?vue&type=template&id=b963950c&"
import script from "./form-clients.vue?vue&type=script&lang=js&"
export * from "./form-clients.vue?vue&type=script&lang=js&"
import style0 from "./form-clients.vue?vue&type=style&index=0&id=b963950c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports